import lpApp from '../lp_app';
import {
  getVariablePass, getOptionPass, lpIdGetCopy, lpIdGetPure,
} from '../../logic/global_getter';
import ConditionsEvo from '../../logic/condition_evo';

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/mandatory.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


class LpMandatory {
  static isShown(id, amVar = true) {
    let op = amVar
      ? lpApp.indexes.grandpa_vars.getVGrandpa(lpIdGetPure(id))
      : lpApp.indexes.grandpa.getFather(lpIdGetPure(id));

    // get fatherZ
    let fathers = [];
    while (typeof op !== 'undefined') {
      fathers.push(op);
      op = lpApp.indexes.grandpa.getFather(op);
    }

    // If it's a copy getting copy fathers
    if (typeof (id) !== 'number') {
      const copy = lpIdGetCopy(id);
      fathers = fathers.map(idx => `${idx}_${copy}`);
    }

    // TODO : CHECK MULTIPLE CONDITIONS WITH NASRO
    const fValues = fathers.map((idx) => {
      // check the conditionning
      let condition = true;
      const opt = lpApp.references.options[lpIdGetPure(idx)]
        ? lpApp.references.options[lpIdGetPure(idx)].meta
        : {};
      if (opt.conditional && opt.compiledConditions.length > 0) {
        // let cond_ = new ConditionRuntime(opt.compiledConditions);
        // cond_.compileDirect();
        // condition = cond_.execute(true);
        condition = ConditionsEvo.getCondition(idx);
      }


      if (condition) {
        let value = (typeof lpApp.indexes.options.getOption(idx) === 'undefined') ? getOptionPass(idx) : lpApp.indexes.options.getOption(idx).value;
        if (opt.type && opt.type === 'static') value = true;
        return value;
      }
      return false;
    });

    if (fValues.length === 0) return true;

    return !(fValues.filter(idx => idx !== true).length > 0);
  }

  static filterStaticsAndCheckboxes(sId) {
    const options = lpApp.references.mandatory_options[sId];
    if (typeof options === 'undefined') return [];
    const result = options.filter(idx => (lpApp.references.options[idx].meta.type === 'static') || (lpApp.references.options[idx].meta.type === 'checkbox'));
    // console.log("Work ", sId, result);
    // test if everyone is conditionned
    const conds = result.map((idx) => {
      const opt = lpApp.references.options[idx];
      if (opt.meta.conditional) {
        // let cond = new ConditionRuntime(opt.meta.compiledConditions);
        // // TODO: multiple check
        // cond.compileDirect();
        // return cond.execute(true);
        return ConditionsEvo.getCondition(idx);
      } return true;
    });
    const r = [];
    result.forEach((idx, i) => {
      if (conds[i]) r.push(idx);
    });
    return r;
  }

  static filterRadios(arr = []) {
    return arr.filter(idx => lpApp.references.options[idx].meta.type === 'radio');
  }

  static checkOption(id) {
    //
    const opt = lpApp.references.options[lpIdGetPure(id)];
    if (typeof opt === 'undefined') return true;
    let children = opt.meta.type === 'checkbox' ? [opt.meta.id] : opt.children;
    children = LpMandatory.filterRadios(children);
    if (children.length === 0) return true;
    let result = children.map((idx) => {
      let copyIdx = idx;
      const copy = lpIdGetCopy(id);
      if (copy !== -2) copyIdx += `_${copy}`;

      return (typeof lpApp.indexes.options.getOption(copyIdx) === 'undefined') ? getOptionPass(copyIdx) : lpApp.indexes.options.getOption(copyIdx).value;
    });
    result = result.filter(idx => idx);
    if (LpMandatory.isShown(id, false)) return (result.length > 0);
    return true;
  }

  static checkVariable(id) {
    const pureId = lpIdGetPure(id);
    const variable = lpApp.references.variables[pureId];
    const variableValue = lpApp.indexes.variables ? lpApp.indexes.variables.getVariable(id) : '';
    let value = (typeof lpApp.indexes.variables.getVariable(id) === 'undefined' ? getVariablePass(id) : lpApp.indexes.variables.getVariable(id).value) !== '';

    if (variable.type === 'number') value = parseInt(variableValue ? variableValue.value : 0, 10) > 0;
    if (variable.type === 'eval') value = true;

    if (LpMandatory.isShown(id)) {
      return typeof value === 'undefined' ? false : value;
    }
    return true;
  }

  static multipleVariablesCopies(sId) {
    // Getting section multiple options
    const mOptions = [];
    lpApp.references.sections[sId - 1].options.forEach((idx) => {
      if (Object.prototype.hasOwnProperty.call(lpApp.indexes.multiples.multiples, idx)) {
        mOptions.push(idx);
      }
    });

    if (mOptions.length === 0) return [];

    // Multiple variables
    const mVars = [];

    // Reading section's mandatory variables to look for
    // multiples
    lpApp.references.mandatory_variables[sId].forEach((idx) => {
      let op = lpApp.indexes.grandpa_vars.getVGrandpa(lpIdGetPure(idx));

      const fathers = [];
      while (typeof op !== 'undefined') {
        fathers.push(op);
        op = lpApp.indexes.grandpa.getFather(op);
      }

      fathers.forEach((fId) => {
        if (mOptions.indexOf(fId) > -1) {
          lpApp.indexes.multiples.multiples[fId].forEach((copy) => {
            mVars.push(`${idx}_${copy}`);
          });
        }
      });
    });

    return mVars;
  }

  multipleOptionsCopies(sId) {
    // Getting section multiple options
    const mOptions = [];
    lpApp.references.sections[sId - 1].options.forEach((idx) => {
      if (Object.prototype.hasOwnProperty.call(lpApp.indexes.multiples.multiples, idx)) {
        mOptions.push(idx);
      }
    });

    if (mOptions.length === 0) return [];

    // Multiple variables
    const mOps = [];

    // Reading section's mandatory variables to look for
    // multiples
    LpMandatory.filterStaticsAndCheckboxes(sId).forEach((idx) => {
      let op = lpApp.indexes.grandpa.getFather(lpIdGetPure(idx));

      const tree = [idx];
      while (typeof op !== 'undefined') {
        tree.push(op);
        op = lpApp.indexes.grandpa.getFather(op);
      }
      tree.forEach((fId) => {
        if (mOptions.indexOf(fId) > -1) {
          lpApp.indexes.multiples.multiples[fId].forEach((copy) => {
            mOps.push(`${idx}_${copy}`);
          });
        }
      });
    });

    return mOps;
  }

  checkMandatoryVariables(sId) {
    if (lpApp.references.mandatory_variables && (sId in lpApp.references.mandatory_variables)) {
      return !((typeof lpApp.references.mandatory_variables[sId] === 'undefined')
        ? true
        : [
          ...lpApp.references.mandatory_variables[sId],
          ...LpMandatory.multipleVariablesCopies(sId),
        ].map(
          idx => LpMandatory.checkVariable(idx),
        ).filter(idx => !idx).length > 0
      );
    }
    return true;
  }


  checkMandatoryOptions(sId) {
    if (lpApp.references.mandatory_options) {
      return (typeof lpApp.references.mandatory_options[sId] === 'undefined')
        ? true
        : [...LpMandatory.filterStaticsAndCheckboxes(sId), ...this.multipleOptionsCopies(sId)].map(
          idx => LpMandatory.checkOption(idx),
        ).filter(idx => !idx).length === 0;
    }
    return true;
  }

  globalCheckVariables() {
    return Object.keys(lpApp.indexes.real_sections.sections).map(
      idx => lpApp.ops.mandatory.checkMandatoryVariables(idx),
    ).filter(idx => !idx).length === 0;
  }

  globalCheckOptions() {
    return Object.keys(lpApp.indexes.real_sections.sections).map(
      idx => lpApp.ops.mandatory.checkMandatoryOptions(idx),
    ).filter(idx => !idx).length === 0;
  }
}

export default LpMandatory;



// WEBPACK FOOTER //
// ./src/app/ops/mandatory.js